var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 31,
    fill: "none",
    className: "social-link"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M29.5312 15.6279c0-8.0273-6.5039-14.5312-14.5312-14.5312S.4687 7.6006.4687 15.6279c0 7.2528 5.314 13.2645 12.2608 14.3555V19.8285H9.0381v-4.2006h3.6914v-3.2015c0-3.6416 2.168-5.6532 5.4885-5.6532 1.5902 0 3.2531.2836 3.2531.2836v3.5743h-1.8328c-1.8047 0-2.3678 1.1203-2.3678 2.2693v2.7275h4.0301l-.6445 4.2006h-3.3856v10.1549c6.9469-1.091 12.2607-7.1027 12.2607-14.3555Z"
  })));
};
export default SvgFacebook;